import { useParams } from "react-router";
import React, { Fragment } from "react";

import PolandArticle from "../components/Articles/PolandArticle";
import CroatiaArticle from "../components/Articles/CroatiaArticle";
import GermanyArticle from "../components/Articles/GermanyArticle";

const CountryDetails = (props) => {
  const params = useParams();
  // const navCtx = useContext(NavBarContext);

  let content = <p>Country not found</p>;

  if (params.countryId === "poland") {
    content = <PolandArticle id={params.id} />;
    // navCtx.toggleShown();
  }

  if (params.countryId === "croatia") {
    content = <CroatiaArticle id={params.id} />;
    // navCtx.toggleShown();
  }

  if (params.countryId === "germany") {
    content = <GermanyArticle id={params.id} />;
    // navCtx.toggleShown();
  }

  return <Fragment>{content}</Fragment>;
};

export default CountryDetails;
